/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRestaurantIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-restaurant"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.5 8.9L6.5 2.92Q6.5 2.38 6.89 1.99Q7.28 1.6 7.83 1.6Q8.38 1.6 8.76 1.99Q9.15 2.38 9.15 2.92L9.15 8.9L9.7 8.9L9.7 2.92Q9.7 2.38 10.09 1.99Q10.47 1.6 11.03 1.6Q11.57 1.6 11.96 1.99Q12.35 2.38 12.35 2.92L12.35 8.9Q12.35 10.4 11.45 11.57Q10.55 12.75 9.15 13.2L9.15 21.27Q9.15 21.82 8.76 22.21Q8.38 22.6 7.83 22.6Q7.28 22.6 6.89 22.21Q6.5 21.82 6.5 21.27L6.5 13.2Q5.1 12.75 4.2 11.57Q3.3 10.4 3.3 8.9L3.3 2.92Q3.3 2.38 3.69 1.99Q4.08 1.6 4.63 1.6Q5.17 1.6 5.56 1.99Q5.95 2.38 5.95 2.92L5.95 8.9ZM17.15 14.45L15.07 14.45Q14.53 14.45 14.14 14.06Q13.75 13.68 13.75 13.13L13.75 7Q13.75 5.05 15.24 3.33Q16.73 1.6 18.4 1.6Q18.98 1.6 19.39 2.02Q19.8 2.45 19.8 3.02L19.8 21.27Q19.8 21.82 19.41 22.21Q19.02 22.6 18.48 22.6Q17.93 22.6 17.54 22.21Q17.15 21.82 17.15 21.27Z" fill={color} />
    </svg>
  );
}
